// React-Screen CBonSearch ("Suchparameter") - Strangler Phase 5 (entschalt).
// Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle bonsearch.js (aus
// lib/scripts/pos/components/CMP_CBonSearch.js).
// Legacy-DOM-Fixture: tests/react-fixtures/CBonSearch.html, gezogen aus
// tests/visual-baseline/30-overlay-bonsuche.html.
//
// ENTSCHALT am 23.8.2026. Dafuer sind die KLICKZIFFERN nach React gekommen
// (ClickNumber/MultiClickNumber/MultiClickDate/MultiClickTime in
// react/widgets.jsx): eine Ziffer ist ein weisses Textfeld mit einer
// unsichtbaren Klicktabelle darueber - obere Haelfte zaehlt hoch, untere
// runter. Gerechnet und gezaehlt wird weiter im Legacy
// (CClickNumber.increase/decrease, CMultiClick*.getValue/setValue), React
// baut nur das DOM.
//
// Eine Eigenheit ist dabei bewusst NACHGEBAUT statt bereinigt: die erste
// Ziffer jeder Datums- und Zeitgruppe hat ZWEI Textfelder und ZWEI
// Klicktabellen uebereinander. CMultiClickDate.addDateComponent ruft
// prepare() dieser Ziffer ein zweites Mal auf; benutzt wird die zweite
// Garnitur. Steht so in der Baseline - also bleibt es so.
//
// Aufrufer ist CPosReceiptList (Bonkopien-Liste) ueber ihren
// "Neue Suche"-Knopf; parentComp wird VOR draw() gesetzt.
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';
import {
  Caption, PushPanel, MultiClickNumber, MultiClickDate, MultiClickTime,
  verdrahteMultiClickNumber, verdrahteMultiClickDate, verdrahteMultiClickTime,
} from '../widgets.jsx';

// Die drei Rahmen mit Beschriftung sehen gleich aus; nur Groesse und Inhalt
// unterscheiden sich (Masse aus LYT_bonSearch.xml).
const UEBERSCHRIFT = { position: 'absolute', left: '0vw', top: '0px', fontSize: '3.0vh', fontWeight: 'bold' };

function BonSearchScreen({ bridge }) {
  const t = bridge.t;

  const suchKnopf = (text, handler, param1, hintergrund, rand) => ({
    text, handler, param0: bridge.id, param1,
    style: { backgroundColor: hintergrund, borderColor: rand, width: '15vw' },
  });

  return (
    <>
      {/* titleContainer */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame"
           style={{ position: 'absolute', left: '0vw', top: '0px', height: '6.8%', width: '100%' }}>
        <Caption bridge={bridge} pfad="0:0" text="Suchparameter"
                 style={{ position: 'absolute', left: '0.5vw', top: '0.7vh',
                          fontSize: '30px', fontWeight: 'bold' }} />
        {/* cancelButton ("X"): schliesst Suche UND Liste dahinter */}
        <div {...bridge.widget('0:1', 'CPushButton', {
               events: { onMousedown: bridge.cancel, onMouseout: true, onMouseup: true },
               attributes: { onMousedown_parameter_0: bridge.id },
               proto: CPushButton.prototype,
             })}
             className="CPushButton"
             style={{ position: 'absolute', right: '0px', top: '0px', width: '3vw', height: '5vh',
                      backgroundImage: 'url(lib/img/08_X.png)', backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center' }}>
          <p {...bridge.el('0:1:0', 'CCaption')} className="CCaption undefined" />
        </div>
      </div>

      {/* bonNumberContainer: neun Klickziffern */}
      <div {...bridge.el('1', 'CFrame')} className="CFrame"
           style={{ position: 'absolute', left: '28vw', top: '8vh', height: '12vh', width: '50vw' }}>
        <Caption bridge={bridge} pfad="1:0" text="Bonnummer:" style={UEBERSCHRIFT} />
        <MultiClickNumber bridge={bridge} pfad="1:1" links="0vw" oben="4vh"
                          vorkomma={9} nachkomma={0} />
      </div>

      {/* dateContainer */}
      <div {...bridge.el('2', 'CFrame')} className="CFrame"
           style={{ position: 'absolute', left: '28vw', top: '25vh', height: '12vh', width: '36vw' }}>
        <Caption bridge={bridge} pfad="2:0" text="Datum:" style={UEBERSCHRIFT} />
        <MultiClickDate bridge={bridge} pfad="2:1" links="0vw" oben="4vh" />
      </div>

      {/* timeContainer */}
      <div {...bridge.el('3', 'CFrame')} className="CFrame"
           style={{ position: 'absolute', left: '28vw', top: '42vh', height: '12vh', width: '26vw' }}>
        <Caption bridge={bridge} pfad="3:0" text="Uhrzeit:" style={UEBERSCHRIFT} />
        <MultiClickTime bridge={bridge} pfad="3:1" links="0vw" oben="4vh" />
      </div>

      {/* searchButtons: 2x2. Die Breite 15vw kommt im Legacy aus dem
          defaultButton der XML und schlaegt die Rasterrechnung. */}
      <PushPanel bridge={bridge} pfad="4" zeilen={2} spalten={2}
                 style={{ width: '31vw', height: '20vh', bottom: '4vh', left: '35vw',
                          visibility: 'visible' }}
                 knoepfe={[
                   suchKnopf(t('BUTTONS', 'BON_NUMBER_SEARCH'), bridge.newSearch, 'bon', '#BBF3BB', '#77CC77'),
                   suchKnopf(t('BUTTONS', 'DATE_SEARCH'), bridge.newSearch, 'datetime', '#BBF3BB', '#77CC77'),
                   suchKnopf(t('BUTTONS', 'RESET'), bridge.resetSearch, undefined, '#FFC57A', '#FF8204'),
                   suchKnopf(t('BUTTONS', 'CANCEL_SEARCH'), bridge.cancelSearch, undefined, '#EE9999', '#DD0000'),
                 ]} />
    </>
  );
}

export const CBonSearch = defineReactScreen({
  className: 'CBonSearch',
  addclass: 'CBonSearch',
  htmlType: 'div',
  Screen: BonSearchScreen,
  // Wurzel-Styles des Legacy-Konstruktors.
  rootStyles: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: '0px',
    top: '0px',
    zIndex: '1',
    backgroundColor: '#DFDFDF',
  },
  // Nach dem Mount nur noch VERDRAHTUNG - das DOM steht (React). Die Namen
  // sind dieselben wie in LYT_bonSearch.xml, damit die Methoden unten
  // woertlich die alten bleiben (sie greifen ueber
  // components.dateContainer.components.date zu).
  mountLegacy(bridge) {
    bridge.nameComponent('0', 'titleContainer');
    bridge.nameComponent('1', 'bonNumberContainer');
    bridge.nameComponent('1:1', 'bonNumber');
    bridge.nameComponent('2', 'dateContainer');
    bridge.nameComponent('2:1', 'date');
    bridge.nameComponent('3', 'timeContainer');
    bridge.nameComponent('3:1', 'time');
    bridge.nameComponent('4', 'searchButtons');

    // Die Ziffern brauchen ihre Legacy-Felder (text/caption/currentValue/
    // numberArray bzw. preCDArray, day/month/year, hour/minute).
    verdrahteMultiClickNumber(bridge, '1:1', 9, 0);
    verdrahteMultiClickDate(bridge, '2:1');
    verdrahteMultiClickTime(bridge, '3:1');

    // Datum und Uhrzeit stehen beim Oeffnen auf JETZT.
    bridge.drawTodayNow();
  },
  methods: {
    newSearch(bridge, component, parameters) {
      var type = parameters[1];

      bridge.parentComp.scrollScreen = 0;
      bridge.parentComp.bestBon = null;
      bridge.parentComp.searchParameters = new Array();

      switch (type) {
        case 'bon':
          var bonNumber = bridge.components.bonNumberContainer.components.bonNumber.getValue();
          bonNumber = parseFloat(bonNumber);
          if (bonNumber == 0) {
            var text = bridge.t('MESSAGES', 'NO_SEARCH_BON');
            POS.message.show(text, 'warning', 'OK');
            return;
          }
          bridge.parentComp.searchParameters[0] = bonNumber;
          break;
        case 'datetime':
          var date = bridge.components.dateContainer.components.date.getValue();
          var dateParts = date.split('.');
          var time = bridge.components.timeContainer.components.time.getValue();
          var timeParts = time.split(':');
          if (!bridge.isDateTimeCorrect(dateParts, timeParts)) {
            var text = bridge.t('MESSAGES', 'INCORRECT_DATE_TIME');
            POS.message.show(text, 'warning', '');
            return;
          }
          bridge.parentComp.searchParameters[1] = parseFloat(dateParts[0]);
          bridge.parentComp.searchParameters[2] = parseFloat(dateParts[1]);
          bridge.parentComp.searchParameters[3] = parseFloat(dateParts[2]);
          bridge.parentComp.searchParameters[4] = parseFloat(timeParts[0]);
          bridge.parentComp.searchParameters[5] = parseFloat(timeParts[1]);
          bridge.parentComp.searchParameters[0] = -1;
          break;
      }
      var v = bridge.parentComp.getBonsToShow();
      $.when(v).then(function (bonsToShow) {
        var v2 = bridge.parentComp.makeBodyList(bonsToShow);
        $.when(v2).then(function () {
          bridge.parentComp.components.listContainer.reDraw();

          bridge.removeMe();
        });
      });
    },
    isDateTimeCorrect(bridge, dateParts, timeParts) {
      var isCorrect = true;

      if (parseFloat(dateParts[0]) > 31 || parseFloat(dateParts[0]) == 0 ||
        parseFloat(dateParts[1]) > 12 || parseFloat(dateParts[1]) == 0 ||
        parseFloat(timeParts[0]) > 23) {
        isCorrect = false;
      }

      return isCorrect;
    },
    resetSearch(bridge) {
      bridge.components.bonNumberContainer.components.bonNumber.setValue('000000000');

      bridge.drawTodayNow();
    },
    drawTodayNow(bridge) {
      var d = new Date();

      var day = d.getDate();
      var month = d.getMonth() + 1;
      var year = d.getYear() - 100;
      var dateNow = day + '.' + month + '.' + year;
      bridge.components.dateContainer.components.date.setValue(dateNow);

      var hours = d.getHours();
      var minutes = d.getMinutes();
      var timeNow = hours + ':' + minutes;
      bridge.components.timeContainer.components.time.setValue(timeNow);
    },
    // "X" oben rechts: Suche UND die Liste dahinter schliessen.
    cancel(bridge) {
      bridge.removeMe();
      bridge.parentComp.removeMe();
    },
    // "Abbrechen": nur die Suche schliessen.
    cancelSearch(bridge) {
      bridge.removeMe();
    },
  },
});
